export default __webpack_public_path__ + "static/media/designer.a8cd22bb.png";